
const BannerData = {
    videoUrl: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2FEV9_Desktop.mp4?alt=media&token=696e705e-9d10-4580-ab50-d35f03623d43",
    title: "The Kia EV9",
    subtitle: "The World's Most inspiring Electric.Ever.",
    price: "",
    features: [
        {
            imgSrc:
                "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2FADAS.webp?alt=media&token=688e4bd4-badb-4427-8b76-36794a5255ac",
            text: "ADAS Level 2 with 27 Autonomous Features",
        },
        {
            imgSrc:
                "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2FOver-1.webp?alt=media&token=3b655809-3280-46a0-a061-1d24f8a65726",
            text: "Over the AirSoftware Updates",
        },
        {
            imgSrc:
                "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2FVehicle-1.webp?alt=media&token=3b665be2-62f4-44a6-9b24-d4fc6fc90c83",
            text: "Vehicle to Load (V2L)",
        },
    ],
};

const caroData = [
    {
        cover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fimage1Over1.webp?alt=media&token=f470f8ba-a2b6-4c1d-823e-3b4625f2f6ba",
        type: "imgbanner",
        title: " ",
        subtitle: " ",
    },
    {
        cover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Flogo2over2.webp?alt=media&token=d9f14905-1ddb-4d8a-b3ce-7cf6ca15042a",
        type: "imgbanner",
        title: " ",
        subtitle: " ",
    },
    // {
    //     cover: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV6%2FSec3-d.avif?alt=media&token=be2c2035-7638-4f65-89de-eb5955b89203",
    //     type: "imgbanner",
    //     title: " ",
    //     subtitle: " ",
    // },
]

const CircleData = [
    {
        title: "Ocean Blue",
        color: "#0083d7",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2F63-dOcean%20Blue.webp?alt=media&token=7558b2a5-b68a-4f52-abe0-b1b687499141",
    },
    {
        title: "Aurora Black Pearl",
        color: "#0d0f10 ",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2F63-d%20(1)%20black%20kia.webp?alt=media&token=48ae54db-e393-41a6-8c99-872e27d1e516",
    },
    {
        title: "Snow White Pearl",
        color: "#dce0dc",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2F63-d%20(2)snow%20white.webp?alt=media&token=fc8b0589-281c-4991-b34e-745d1e0a0136",
    },
    {
        title: "Panthera Metal",
        color: "#6e767a",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fpanther.webp?alt=media&token=39f1573f-b221-4142-8a25-1f6892a21f62",
    },
    {
        title: " Pebble Gray",
        color: "#8f9599",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fpabble%20gray.webp?alt=media&token=07ba0150-c79e-427c-a9b3-fe58326f4843",
    },
];

const TrimData = [
    {
        title: "GT-Line AWD",
        cost: "1,29,90,000",
        feature1: `Advance *ADAS Package with 27 features`,
        feature2: "Digital Pattern Lightning Grille with Welcome Function",
        feature3: "Trinity Panoramic Display 12.3” Cluster + 5” HVAC + 12.3” Infotainment",
        feature4: "Over the Air System Update",
        feature5: "Digital Key 2.0",
        feature6: "Second Row Captain Seats with Relaxation and Massage Function",

    },
]

const DetailInfo = [
    {
        bgColor: "#FFF",
        color: "#000",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
        title: "Book Your EV9 Today",
        desc: "Its time to own the most inspiring Kia ever",
        link: "",
    },
    {
        bgColor: "#05141f",
        color: "#FFF",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/download.png?alt=media&token=9de03b22-8ba2-433e-9ff0-a78165faaf3a",
        title: "Download Brochure",
        desc: "Learn more about its wild possibilities",
        link: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV9%2FKia_EV9_Brochure_Desktop.pdf?alt=media&token=ec36b7aa-3ab1-4d72-9837-ea92bc1e07d8",
    },
    {
        bgColor: "#FFF",
        color: "#000",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
        title: "Call us for more information",
        desc: "We'll be happy to answer all your queries. 0000000000",
        link: "tel:+919237386213",
    },
];

const caro3in1Data = [
    {
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard1.webp?alt=media&token=e7468593-e0fd-44ba-bc72-fb611e13997a",
        title: '*ADAS Level-2 with 27 Autonomous Features ',
        desc: 'Ever vigilant and always ready to step in, the EV9 ensures the ultimate active and passive safety. With more than 27 *ADAS functions and a plethora of other features, everyone in and around the EV9 stays safe and in control.',
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard2.webp?alt=media&token=fc1fabb9-93a5-410d-9e21-f0f4b6e4ea66",
        title: 'Digital Pattern Lighting Grille',
        desc: 'The sleek and muscular body of the EV9 features the Digital Pattern Lighting Grille with Intelligent Ice Cube LED Projection Headlamps; it certainly leaves a lasting impression on everyone.',
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard3.webp?alt=media&token=30ef3940-794e-4474-a025-c7059507a071",
        title: 'Trinity Panoramic Display',
        desc: 'Technology is integrated seamlessly, and every element is chosen to provide a modern, and convenient driving experience. Navigate and control every drive with the dynamic 12.3” Instrument Cluster​ + 5” HVAC Controls ​+ 12.3” Touchscreen Navigation.',
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard4.webp?alt=media&token=a55196d3-fe54-4011-9f89-ea83a05bb06d",
        title: 'Over the Air Software Updates​',
        desc: 'Let your vehicle evolve effortlessly with wireless upgrades.',
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard5.webp?alt=media&token=9de2490e-a4f0-440f-a18e-8d12e66f6b42",
        title: '2nd Row Captain Seats with Relaxation &amp; Massage Function',
        desc: 'The 2nd row captain seats with relaxation and massage functions transform your ride into a sanctuary. Experience customizable comfort and luxury, all the way',
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard6.webp?alt=media&token=5aeca60f-eaf9-4ecb-8569-b706a11247d7",
        title: 'Dual Sunroof',
        desc: 'Embrace the open sky with the Kia EV9’s dual sunroof and enhance your connection with the world beyond.',
    },
    {
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard7.webp?alt=media&token=5ac2e128-459e-4171-8429-1b4932ee64f1",
        title: 'Digital IRVM',
        desc: 'Experience enhanced visibility with the IRVMs integrated digital screen, offering a real-time rear camera view. Say goodbye to blind spots and enjoy safer, more confident driving, even in challenging conditions.',
    },

];

const gridData = [
    {
        type: 'img',
        item: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fevcard9.webp?alt=media&token=c7ec55ee-58d6-436a-87e5-a014c69d9f32",
    },
    {
        type: 'text',
        item1: "A Vision of Comfort and Craftsmanship",
        item2: "Trinity Panoramic Display",
        item3: "Immerse yourself in a cutting-edge driving experience with the Trinity Panoramic Display. Seamlessly blending three high-definition screens, it offers a unified view of navigation, controls, and entertainment at your fingertips.",
    },
    {
        type: 'img',
        item: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard2.webp?alt=media&token=fc1fabb9-93a5-410d-9e21-f0f4b6e4ea66",
    },
    {
        type: 'text',
        item1: "2nd Row Captain Seats with Relaxation & Massage Function",
        // item2: "Driver and Passenger Relaxation Seats",
        item3: "The 2nd row captain seats with relaxation and massage functions transform your ride into a sanctuary. Experience customizable comfort and luxury, all the way.",
    },
    {
        type: 'img',
        item: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard3.webp?alt=media&token=30ef3940-794e-4474-a025-c7059507a071",
    },
    {
        type: 'text',
        item1: "Head-up Display – Windshield Projection",
        // item2: "Driver and Passenger Relaxation Seats",
        item3: "Stay focused on the road with the Head-up Display, projecting key driving information directly onto your windshield. Enjoy a safer, distraction-free experience with navigation, speed, and alerts always in your line of sight.",
    },
];

const com3struct = [
    {
        type: "text",
        backgroundColor: "#1d1d1d",
        color: "white",
        heading: "Power to your journeys",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Ffull1.webp?alt=media&token=e78fec79-e2c7-48d5-aa65-0b599b75bd4a",
        description: [
            "The EV9's exhilarating performance comes from its high-powered motors, which deliver 282.6 kW power and 700 Nm of torque.Coupled with a high-energy battery that goes from 10% to 80% in just 24 minutes**,this electric is unstoppable, no matter how long the road.",
        ],
        height: {
            md: "79vh",
            sm: "42vh",
            xs: "22vh",
        },
    },

    {
        type: "cards",
        items: [
            {
                title: "Electric–Global Modular Platform (E-GMP)",
                description: "E-GMP forms the basis for the Kia EV9. It offers revolutionary EV technology such as 800-volt ultra-fast charging, bi-directional charging capabilities such as Vehicle-to-Load (V2L) and incorporates the latest generation of EV batteries",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fevcard1electric01.webp?alt=media&token=3eddffb5-7018-460c-9c22-2fac743fdb97",
            },
            {
                title: "AWD Powertrain",
                description: "The Kia EV9 comes equipped with two permanent magnet synchronous motors, one on each axle, with a total combined power output of 282.6 Kw and 700 Nm of torque.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fevcard2electric02.webp?alt=media&token=d1219bbf-0a0d-422d-b596-ab8f2fac48d2",
            },
            {
                title: "Drive &amp; Terrain Modes",
                description: "The Kia EV9 comes with different Drive Modes designed to suit different driver preferences on the road. The Terrain Modes regulate the torque and transmits the power per wheel selectively.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fevcard3electric03.webp?alt=media&token=1b03759a-5ed1-401d-b688-d8351d9854e4",
            },
        ],
    },
    {
        type: "image",
        backgroundColor: "#1d1d1d",
        color: "white",
        heading: "Back on the road before you know it",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Ffull2.webp?alt=media&token=8179d836-12fe-487e-a49d-bd589be36dc1",
        height: {
            md: "70vh",
            sm: "42vh",
            xs: "22vh",
        },
    },

    {
        type: "cards",
        items: [
            {
                title: "Vehicle to Load (V2L) ",
                description: "V2L can be divided into two types: V2L Inside (socket in the interior) and V2L Outside (V2L connector in the charging socket). Both deliver a maximum output of 3.68 kW which can be used to charge or power electric devices or other electric vehicles.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fevcard4lap.webp?alt=media&token=f1957a17-bd7b-4e08-a434-64f5284a2caa",
            },
            {
                title: "^^Range: 561 KM",
                description: "Experience the freedom to explore with confidence. The Kia EV9 offers an impressive range, ensuring every journey, whether long or short, is worry-free and filled with unmatched possibilities.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fevcard5car.webp?alt=media&token=b793ed6c-6874-4d67-a2a1-886fa92387be",
            },

        ],

    },
    {
        type: "image",
        backgroundColor: "#1d1d1d",
        color: "white",
        heading: "The Strongest Bond",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Ffull3.webp?alt=media&token=cb6f5326-b954-4d57-aed0-8e7e7bf6df4b",
        description: [
            "Stay in sync with the EV9 no matter where you are. More than 100 connected car features, dynamic solutions, and seamless integrations make owning this electric a joyful experience with Kia Connect 2.0.",
        ],
        height: {
            md: "80vh",
            sm: "60vh",
            xs: "40vh",
        },
    },
    {
        type: "cards",
        items: [
            {
                title: "Kia Connect 2.0 ",
                description: "Stay connected to your EV9 with more than 100 connected car features, like CCNC – Connected Car Navigation Cockpit, Kia Connect Diagnosis for your car, Advanced Total Care System and much more.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fevcard6.webp?alt=media&token=5789f396-e149-43c8-b4ab-15f43765f7e5",
            },
            {
                title: "Digital Key 2.0​",
                description: "Your Digital Key 2.0 can be installed on the smartphone for touch control or remote control, as well as key sharing with family and friends. Enjoy the convenience of locking/unlocking your car even without taking your smartphone out of your pocket.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fevcard7.webp?alt=media&token=7b5ffc41-059a-4894-bffa-2d2008f12fb2",
            },
            {
                title: "Over-the-Air Software Updates​",
                description: "Your EV9 evolves with you. Receive automatic updates to software and features over the air, ensuring that your vehicle is always equipped with the latest technology, enhancements, and performance improvements—all without stepping into a service centre.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fevcard8.webp?alt=media&token=b60a613f-66f8-4f4c-924e-d7ac15876ea7",
            },

        ],
    },
    {
        type: "image",
        backgroundColor: "#1d1d1d",
        color: "white",
        heading: "Room for life",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Ffull4.webp?alt=media&token=77addd21-c182-4824-94e3-593885014c3d",
        description: [
            "There's room for everyone and everything in the EV9. A versatile cabin design balances the space for occupants and belongings, while the flat floor creates an expansive interior space.",
        ],
        height: {
            md: "80vh",
            sm: "60vh",
            xs: "40vh",
        },
    },
    {
        type: "cards",
        items: [
            {
                title: "2nd Row Captain Seats with 8-Way Power Adjust and Massage Function",
                description: "Indulge in first-class comfort with 8-way power-adjustable captain seats, complete with a soothing massage function. Your second-row passengers can enjoy personalized seating adjustments for ultimate relaxation on every journey.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs14-1.webp?alt=media&token=d3cb6a96-11b9-4e47-9233-97467913f6b3",
            },
            {
                title: "Independently Controlled 3-zone Fully Automatic Temperature Control​",
                description: "Achieve perfect comfort for every passenger with 3-zone automatic temperature control. Each zone operates independently, allowing personalized climate settings for the driver, front passenger, and rear occupants for a tailored in-car experience.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs14-2.webp?alt=media&token=9290ba80-eed6-41ab-adb1-a2c26ffd1c22",
            },
            {
                title: "2nd Row One Touch Fold Seat",
                description: "Maximize space effortlessly with the 2nd row's one-touch fold feature. Whether you need extra room for cargo or passengers, this convenient function allows quick and easy seat adjustments for flexible interior configurations.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs14-3.webp?alt=media&token=5a321e4e-2f40-4d58-9aa3-56af6038db0d",
            },
            {
                title: "Frunk* (52l)​",
                description: "The Kia EV9 offers a convenient Frunk (Front Trunk) with 52 liters (AWD) or 90 liters (RWD) of additional storage space.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs14-4.webp?alt=media&token=77501ef5-c33c-41c5-b81d-b0096746fbbd",
            },
            {
                title: "Spacious Boot* (333l)​",
                description: "With a generously spacious boot, the Kia EV9 offers ample room for all your gear, ensuring you're ready for any adventure, big or small.​",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs14-5.webp?alt=media&token=8d9e4801-32ab-47e7-9f6d-b1627dbcb764",
            },
            {
                title: "Extendable Central Console Tray with Under Storage​",
                description: "Stay organized with the extendable central console tray, offering added convenience and hidden storage. Perfect for keeping your essentials within reach while maintaining a clean and uncluttered cabin.",
                image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV9%2Fevcard14.jpg?alt=media&token=f6c73150-f778-4ced-bac3-f68f334566f9",
            },

        ],
    },


    {
        type: "image",
        backgroundColor: "#1d1d1d",
        color: "white",
        heading: "Tech that goes the distance",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs15-1-d.webp?alt=media&token=590c9234-8d3c-4259-a46c-71b5dd1bbe39",
        description: [
            "Designed to be intuitive with cutting-edge yet effortless technology, the EV9 is an inspiring electric.            With such futuristic tech, every drive will be a breeze.",
        ],
        height: {
            md: "80vh",
            sm: "60vh",
            xs: "40vh",
        },
    },




    {
        type: "cards",
        items: [
            {
                title: "Shift-by-wire Selector ",
                description: " Experience seamless gear shifts by turning the dial with the Shift- by - Wire selector.This advanced technology enhances driving precision while decluttering the cabin for a clean, modern interior feel.  ",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs16-1.webp?alt=media&token=e705f549-5d4e-48a2-9c33-4fd82024b315",
            },
            {
                title: "Digital IRVM",
                description: "Experience enhanced visibility with the IRVM's integrated digital screen, offering a real-time rear camera view. Say goodbye to blind spots and enjoy safer, more confident driving, even in challenging conditions. ",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs16-2.webp?alt=media&token=3c743c69-1e6c-413b-b33c-2b56a1ca2dab",
            },
            {
                title: "Vehicle-to-load (V2L)",
                description: " V2L can be divided into two types: V2L Inside (socket in the interior) and V2L Outside (V2L connector in the charging socket). Both deliver a maximum output of 3.68 kW which can be used to charge or power electric devices or other electric vehicles. ",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs16-3.webp?alt=media&token=2de5c2d7-91b2-4c67-a7e4-1be12c323b38",
            },
            {
                title: "Smart Power Tailgate",
                description: " Effortless access at the wave of a hand. The smart power tailgate opens automatically, giving you hands-free convenience for loading and unloading with ease.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs16-4.webp?alt=media&token=216890a2-d244-46e0-8381-55cdea6ebddc",
            },
            {
                title: "Meridian Premium Sound System with 14 Speakers ",
                description: "With 14 precision-tuned Meridian speakers, the EV9 delivers immersive, crystal-clear audio that transforms your cabin into a personal soundstage.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fabcd.webp?alt=media&token=e87ec54c-33a8-4502-9a5b-1a9009bef22b",
            },


        ],
    },
    {
        type: "image",
        backgroundColor: "#1d1d1d",
        color: "white",
        heading: "Safety that’s electrifying.",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fseven1d.webp?alt=media&token=15c8626d-514e-4ca6-92af-bfd3259c5cf3",
        description: [
            " With over 27 advanced *ADAS functions, the EV9 redefines safety by combining cutting-edge innovation with a focus    on both active and passive protection. Engineered to keep everyone in and around the vehicle safe, it ensures you stay in control, no matter the journey ahead.",
        ],
        height: {
            md: "80vh",
            sm: "60vh",
            xs: "40vh",
        },
    },




    {
        type: "cards",
        items: [
            {
                title: "10 Airbags",
                description: " Designed to protect from every angle, the EV9 ensures peace of mind with 10 strategically placed airbags.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs17-1.webp?alt=media&token=a66f6ccf-a50a-4ca2-8ca1-6224d3cfc346",
            },
            {
                title: "*ADAS Level 2",
                description: "Advanced driving assistance at your fingertips, empowering you with confidence and control on every journey.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs17-2.webp?alt=media&token=5c81fa81-5aae-44d4-908b-e975a9b6e97d",
            },
            {
                title: "Forward Collision Avoidance Assist - Junction Crossing",
                description: "Stay ahead of the unexpected with intelligent collision avoidance that adapts to every intersection. ",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs17-3.webp?alt=media&token=e1c0f703-7821-4177-8353-496db2a6fa23",
            },
            {
                title: "Blind Spot Collision Avoidance Assist",
                description: "  Eyes where you can’t see; advanced sensors ensure safe lane changes with blind spot collision avoidance. ",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs17-4.webp?alt=media&token=efe37421-dffd-4a5a-a91d-61b584e7e779",
            },
            {
                title: "360-Degree Camera",
                description: "  Never miss a detail with the 360-degree camera that surrounds you with an all-seeing eye for ultimate precision.",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fs17-6.webp?alt=media&token=cf4d476c-c1f3-41da-8ac6-c5609bd72d7d",
            },

            {
                title: "Blind View Monitor",
                description: "Innovative technology that brings your blind spots into view, enhancing safety with every turn. ",
                image: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV9%2Fcarousel%2Fs17-5.avif?alt=media&token=87d3000d-bfe9-4623-a95c-5f9f44807897",
            },


        ],
    },
]

const Caro3Heading = {
    heading: "Meet the 2024 World Car of the Year"
}



export { BannerData, caroData, CircleData, TrimData, DetailInfo, caro3in1Data, gridData, com3struct, Caro3Heading };